<template>
  <div>
    <transition name="fade-slow">
      <loader v-if="loading" :full="true" class="xs-hide md-hide z4"></loader>
    </transition>

    <mq-layout mq="lg">
      <div v-if="showLiveStatus && liveStreamStatus === 'upcoming'" id="live-status" class="caps green">
        Live Broadcast Begins in {{ liveStreamCounter }}<br />
        {{ liveStream.fields.Title }}
      </div>
      <div id="live" @keyup.up="channelUp" @keyup.right="channelUp" @keyup.down="channelDown" @keyup.left="channelDown" tabindex="0" class="z1">
        <div id="hamburger" class="z2 green"><router-link to="/videos"><img src="../assets/hamburger.svg" /></router-link></div>
        <video v-if="liveStreamStatus !== 'current'" id="bgvid" ref="player" :muted="isMuted" playsinline></video>
        <iframe v-else-if="liveStreamStatus === 'current'" ref="live-iframe" width="560" height="315" :src="liveSrc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <ul id="channelSelector" class="flex m0 z2" v-if="channels" @mouseover="showLiveStatus = false" @mouseleave="showLiveStatus = true">
          <li v-for="(stream, index) in streams" @click="loadChannel(index)" :key="stream.video_id" :class="{ active: isActive(index) }">
            <div class="channelInfo information green caps">
              CHANNEL {{ index + 1 }} BROADCAST<br/>
              {{ stream.video.title }}<br/>
              ↙
            </div>
          </li>
        </ul>
        <div id="channelNumber" class="z2">{{ currentChannel + 1 }}</div>
        <div id="volumeControl" class="z2" @click.stop="setVolume">
          <div class="volumeControlBg"></div>
          <div class="volumeControlBar" :style="volumeStyle"></div>
        </div>
      </div>
      <div id="live-toggle" @click="goToLive()" class="z1" :class="{ 'pointer': !isLive }"></div>
    </mq-layout>
  </div>
</template>

<script>
import Airtable from 'airtable'
import { mapState, mapActions } from 'vuex'
import Loader from '@/components/Loader'
import { distanceInWordsStrict } from 'date-fns'
const base = new Airtable({apiKey: process.env.AIRTABLE_KEY}).base('appZ0tDHc4bbcoeU1')

export default {
  name: 'Live',
  components: {
    Loader
  },
  data () {
    return {
      live: false,
      liveStream: false,
      liveStreamStatus: false,
      liveStreamCounter: false,
      currentChannel: 0,
      isMuted: true,
      volume: 0.1,
      loading: true,
      videoPlayer: null,
      initialized: false,
      showLiveStatus: true
    }
  },
  created: function () {
    // If mobile, go straight to videos
    if (this.$route.name === 'Live' &&
      (this.$mq === 'sm' || this.$mq === 'md')) {
      this.$router.push('videos')
    } else {
      this.getChannels()
    }
  },
  mounted: function () {
    // Check livestream
    // let self = this
    // self.updateLiveStreamData()
    window.setInterval(function () {
      // self.updateLiveStreamData()
    }, 60000)
    window.setInterval(function () {
      // self.updateLiveStreamStatus()
    }, 1000)
  },
  computed: {
    ...mapState([
      'channels'
    ]),
    liveSrc () {
      return `https://www.youtube.com/embed/${this.liveStream.fields.id}?origin=https://soe.tv&autoplay=1`
    },
    isLive: function () {
      return this.$route.name === 'Live'
    },
    streams: function () {
      return this.channels.map(x => x.stream_position)
    },
    volumeStyle: function () {
      return {
        'width': this.volume * 100 + '%'
      }
    },
    dev: function () {
      return process.env.NODE_ENV === 'development'
    }
  },
  watch: {
    channels: function () {
      if (!this.initialized && this.$mq !== 'sm') {
        this.initialized = true
        this.initVideo()
      }
    },
    liveStreamStatus: function () {
      this.$nextTick(() => {
        setTimeout(() => { this.initVideo() }, 1000)
      })
    }
  },
  methods: {
    ...mapActions([
      'getChannels'
    ]),
    distanceInWordsStrict,
    updateLiveStreamData () {
      console.log('>>> Update Live Stream Data')
      let self = this
      base('Livestream').find('recsZ28V1PQZ4knlO',
        function (err, record) {
          if (err) {
            console.error(err)
            return
          }
          self.liveStream = record
        })
    },
    updateLiveStreamStatus () {
      console.log('>>> Update Live Stream Status')
      if (this.liveStream.hasOwnProperty('fields')) {
        let diff = new Date() - new Date(this.liveStream.fields.Start)
        if (this.liveStream.fields.Active && diff < 0) {
          // Active, starts in future
          this.liveStreamStatus = 'upcoming'
          this.liveStreamCounter = distanceInWordsStrict(new Date(), this.liveStream.fields.Start)
        } else if (this.liveStream.fields.Active && diff > 0) {
          // Active, started in past
          this.liveStreamStatus = 'current'
          this.liveStreamCounter = distanceInWordsStrict(new Date(), this.liveStream.fields.Start)
        } else {
          // Other
          this.liveStreamStatus = false
          this.liveStreamCounter = false
        }
      } else {
        this.liveStreamStatus = false
        this.liveStreamCountdown = false
      }
    },
    initVideo: function () {
      if (this.liveStreamStatus === 'current') {
        setTimeout(() => { this.loading = false }, 750)
      } else {
        this.$refs.player.pause()
        this.$refs.player.volume = this.volume
        let currentVideoFiles = this.channels[this.currentChannel].stream_position.video.files
        let videoFiles = currentVideoFiles.filter(file => file.quality === 'hd')

        if (videoFiles.length === 0) {
          videoFiles = currentVideoFiles.filter(file => file.quality === 'sd')
        }

        this.$refs.player.setAttribute('src', videoFiles[0].link_secure)

        this.$refs.player.addEventListener('loadeddata', () => {
          this.$refs.player.currentTime = this.channels[this.currentChannel].stream_position.time
          this.$refs.player.play()
        })
        this.$refs.player.addEventListener('ended', () => {
          this.loadChannel(this.currentChannel)
        })
        this.$refs.player.addEventListener('canplay', () => {
          setTimeout(() => { this.loading = false }, 750)
        })
      }
    },
    loadChannel: function (channel) {
      this.loading = true
      this.getChannels(true).then(response => {
        this.currentChannel = channel
        this.$refs.player.pause()
        let currentVideoFiles = this.channels[this.currentChannel].stream_position.video.files
        let videoFiles = currentVideoFiles.filter(file => file.quality === 'hd')

        if (videoFiles.length === 0) {
          videoFiles = currentVideoFiles.filter(file => file.quality === 'sd')
        }

        this.$refs.player.setAttribute('src', videoFiles[0].link_secure)
        this.$refs.player.currentTime = this.channels[this.currentChannel].stream_position.time
      })
    },
    goToLive: function () {
      if (this.$route.name !== 'Live') {
        this.$router.push('/')
      }
    },
    isActive: function (index) {
      return index === this.currentChannel
    },
    setVolume: function (event) {
      let volumeAmount = (event.offsetX / 380).toFixed(2)
      if (volumeAmount > 0.93) {
        this.isMuted = false
        this.volume = 1.0
      } else if (volumeAmount < 0.25) {
        this.isMuted = true
        this.volume = 0
      } else {
        this.isMuted = false
        this.volume = parseFloat(volumeAmount)
      }
      this.$refs.player.volume = this.volume
    },
    channelUp: function () {
      this.loadChannel((this.currentChannel + 1) % (this.channels.length))
    },
    channelDown: function () {
      if (this.currentChannel - 1 < 0) {
        this.loadChannel(this.channels.length - 1)
      } else {
        this.loadChannel(this.currentChannel - 1)
      }
    }
  }
}
</script>

<style lang="css" scoped>
#live {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--color-black);

  ::selection {
    background: none;
  }

  a {
    color: var(--color-green);
    text-decoration: none;
  }
}

#live-toggle {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  &.pointer {
    display: block;
    cursor: pointer;
  }
}

video#bgvid {
  position: fixed;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -100;
  -ms-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  background-size: cover;
  transition: all 0.2s ease-out;

  &.blur {
    filter: blur(12px);
  }
}

.videoContainer {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

iframe {
  /* optional */
  width: 100%;
  height: 100%;
  pointer-events: none;
}

#hamburger {
  position: fixed;
  top: 3.5rem;
  left: 3rem;
}
#live-status {
  position: fixed;
  bottom: 6rem;
  left: 3rem;
  z-index: 9999;
  font-size: var(--font-size-tate);
}
#channelSelector {
  position: fixed;
  padding: 0;
  bottom: 3rem;
  left: 3rem;
  li {
    border: 1px solid var(--color-green);
    border-right: none;
    list-style: none;
    height: 24px;
    width: 78px;
    cursor: pointer;

    .channelInfo {
      display: none;
      position: absolute;
      bottom: 32px;
      width: 475px;
    }

    &:hover {
      .channelInfo {
        display: block;
      }
    }

    &:hover, &.active {
      background: var(--color-green);
    }

    &:last-child {
      border-right: 1px solid var(--color-green);
    }
  }
}
#channelNumber {
  position: fixed;
  top: 0.25rem;
  line-height: 1;
  right: 3rem;
  font-size: 230px;
  color: var(--color-green);
  pointer-events: none;
}
#volumeControl {
  position: fixed;
  bottom: 3rem;
  right: 3rem;
  width: 380px;
  height: 100px;
  cursor: pointer;

  .volumeControlBg {
    background: url('../assets/volume-slider.svg');
    opacity: 0.3;
    width: 100%;
    height: 100%;
  }

  .volumeControlBar {
    background: url('../assets/volume-slider.svg');
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: width 0.3s ease-out;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Live.vue